type ResolveFlagsmithIdentityArgs = {
  isCustomer: boolean;
  salesRepContactId: string | undefined;
  authIdentity: string | undefined;
};

const resolveFlagsmithIdentity = ({
  isCustomer,
  salesRepContactId,
  authIdentity,
}: ResolveFlagsmithIdentityArgs): string | undefined => {
  if (isCustomer) {
    return salesRepContactId || authIdentity || undefined;
  }

  return authIdentity || undefined;
};

export { resolveFlagsmithIdentity };
export type { ResolveFlagsmithIdentityArgs };
